export enum EnterpriseAttachmentEnum {
  PRINCIPAL = 'PRINCIPAL',
  PLANTS = 'PLANTS',
  CAMPAIGNS = 'CAMPAIGNS',
  GENERAL = 'GENERAL',
}
